(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .controller('EditAccountUserController', EditAccountUserController);

  /* ngInject */
  function EditAccountUserController($state, $stateParams, Flash, accountProductService, accountProductRoleService, accountUserService, fiService, formErrorsService, sessionService) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.activate = activate;
    vm.deleteUser = deleteUser;
    vm.getAccountProducts = getAccountProducts;
    vm.getUser = getUser;
    vm.getUserProductRoles = getUserProductRoles;
    vm.products = [];
    vm.saveUser = saveUser;
    vm.saveUserProductRoles = saveUserProductRoles;
    vm.user = {};
    vm.userForm = {};
    vm.userProductRoles = {};

    vm.activate();

    function activate() {
      getUser();
      getAccountProducts();
      getUserProductRoles();
    }

    function deleteUser() {
      vm.clearFormErrors(vm.userForm);
      accountUserService(sessionService.getAuthToken()).destroy({id: $stateParams.id});
      $state.go('application.compliance_framework.edit_account');
    }

    function getAccountProducts() {
      accountProductService(sessionService.getAuthToken()).query(response => {
        vm.products = response;
      });
    }

    function getUser() {
      accountUserService(sessionService.getAuthToken()).get({id: $stateParams.id}, response => {
        vm.user = response;
      });
    }

    function getUserProductRoles() {
      accountProductRoleService(sessionService.getAuthToken()).query({accountUserId: $stateParams.id}, response => {
        response.forEach(productRole => {
          if (!vm.userProductRoles[productRole.product_id]) {
            vm.userProductRoles[productRole.product_id] = [productRole.role_id];
          } else {
            vm.userProductRoles[productRole.product_id].push(productRole.role_id);
          }
        });
      });
    }

    function saveUser(user) {
      accountUserService(sessionService.getAuthToken()).update({fiId: $stateParams.fiId, id: $stateParams.id, user}, _updateUserSuccess, _saveUserFailure);
    }

    function saveUserProductRoles() {
      let roleIds = [];

      for (let productId in vm.userProductRoles) {
        for (let i = 0; i < vm.userProductRoles[productId].length; i++) {
          roleIds.push(vm.userProductRoles[productId][i]);
        }
      }

      accountProductRoleService(sessionService.getAuthToken()).save({accountUserId: $stateParams.id, role_ids: roleIds}, _saveUserProductRolesSuccess);
    }

    function _saveUserProductRolesSuccess(_response) {
      Flash.create('success', 'The user roles were successfully updated.');
    }

    function _updateUserSuccess(_response) {
      Flash.create('success', 'The user was successfully updated.');
    }

    function _saveUserFailure(response) {
      vm.setFormErrors(vm.form, response);
      Flash.create('danger', 'An error occurred with the submission. Please correct the errors on the form and resubmit.');
    }
  }
})();
